import React from 'react';
import { useSelector } from "react-redux";

import Toast from './Toast';

function ToastWrapper() {
  const toasts = useSelector( state => state.toasts );
  return (
    <div className={'flexColumn toasts-container'}>
      {toasts.map( (x,i) => <Toast key={x.key} id={x.key + i} content={x.content} duration={x.duration} typeClass={x.typeClass} iconStyle={x.iconStyle} /> )}
    </div>
  )
}

export default ToastWrapper;
